import { DateSeries, IndexSeries, FixedSeries, RemoteDateSeries, RemoteIndexSeries, RemoteFixedSeries, DateDatum, IndexDatum } from '../DataSeries';
import { convertToJSON } from "../Util";
import { DataTypes } from './';

const d3 = require('d3');


/**
 * Load a saved data series
 * 
 * @param {JSON} data JSON with raw data and attributes
 */
export function loadData(dataString) {
  if (dataString === null) {
    return null;
  }

  let dataJSON = convertToJSON(dataString);
  dataJSON = applyBackwardCompatibility(dataJSON);

  if (dataJSON.type === DataTypes.DATE_REMOTE) {
    return loadRemoteSeries(dataJSON, RemoteDateSeries);
  }
  else if (dataJSON.type === DataTypes.DATE) {
    return loadDateSeries(dataJSON);
  }
  else if (dataJSON.type === DataTypes.INDEX_REMOTE) {
    return loadRemoteSeries(dataJSON, RemoteIndexSeries);
  }
  else if (dataJSON.type === DataTypes.INDEX) {
    return loadIndexSeries(dataJSON);
  }
  else if (dataJSON.type === DataTypes.FIXED_REMOTE) {
    return loadRemoteSeries(dataJSON, RemoteFixedSeries);
  }
  else if (dataJSON.type === DataTypes.FIXED) {
    return loadFixedSeries(dataJSON);
  }
  else {
    throw Error('loadData input data class is not recognized');
  }
}


/**
 * Convert the parsed JSON of an older-spec data to the new spec to
 * enable easier backward compatibility
 * 
 * @param {JSON} dataJSON Converted dataJSON to check for compatibility
 */
function applyBackwardCompatibility(dataJSON) {
  if (Array.isArray(dataJSON)) { 
    return { type: DataTypes.DATE, raw: dataJSON };
  } else if (!dataJSON.type && dataJSON.remoteID) {
    return { type: DataTypes.DATE_REMOTE, remoteID: dataJSON.remoteID };
  } else {
    return dataJSON;
  }
}


/**
 * Convert the saved data JSON into an initialized DateSeries
 * 
 * @param {JSON} dataJSON Saved data JSON
 */
function loadDateSeries(dataJSON) {
  let utcRawParse = d3.utcParse("%Y-%m-%dT%H:%M:%S.%LZ");
  let dataRaw = convertToJSON(dataJSON.raw);

  let dataArray = dataRaw.map(d => {
    if ('date' in d) { // TODO: DELETE, FOR BACKWARD COMPATIBILITY
      return new DateDatum(utcRawParse(d.date), d.value);
    } else {
      return new DateDatum(utcRawParse(d[0]), d[1]);
    }
  });

  return new DateSeries(dataArray);
}


/**
 * Convert the saved data JSON into an initialized IndexSeries
 * 
 * @param {JSON} dataJSON Saved data JSON
 */
function loadIndexSeries(dataJSON) {
  let dataRaw = convertToJSON(dataJSON.raw);
  let dataArray = dataRaw.map((d,i) => new IndexDatum(i, d));

  return new IndexSeries(dataArray);
}


/**
 * Convert the saved data JSON into an initialized FixedSeries
 * 
 * @param {JSON} dataJSON Saved data JSON
 */
function loadFixedSeries(dataJSON) {
  let dataRaw = convertToJSON(dataJSON.raw);
  return new FixedSeries(dataRaw);
}


/**
 * Convert the saved data JSON into an initialized remote series
 * 
 * @param {JSON} dataJSON Saved data JSON
 * @param {RemoteDateSeries|RemoteIndexSeries|RemoteFixedSeries} seriesClass 
 */
function loadRemoteSeries(dataJSON, seriesClass) {
  return new seriesClass(dataJSON.remoteID);
}